import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { physicalDetailsSchema } from '../../../ValidationSchema';
import { editLifeStyleDetails, getAllPhysicalStatus, getWeight } from '../../../../asiosConfig';
import Popup from '../../../Popup';
import { Button, Card, CardContent, CardHeader, MenuItem, TextField } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

export const LifestyleEdit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const physicalData = location.state?.userProfileData || {};
  const [weight, setWeight] = useState([]);
  const [physicalStatus, setPhysicalStatus] = useState([]);
  const [bodyType, setBodyType] = useState([]);
  const [complexion, setComplexion] = useState([]);
  const [eatingHabits, setEatingHabits] = useState([]);
  const [drinkingHabits, setDrinkingHabits] = useState([]);
  const [smokingHabits, setSmokingHabits] = useState([]);
  const [popupData, setPopupData] = useState({ open: false, type: '', message: '' });

  const handleClosePopup = () => {
    setPopupData({ ...popupData, open: false });
  };

  useEffect(() => {
    if (popupData.open) {
      const timer = setTimeout(() => {
        setPopupData(prev => ({ ...prev, open: false }));
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [popupData.open]);

  const formik = useFormik({
    initialValues: {
      Weight: physicalData.weight || '',
      Weight_ids: physicalData.Weight_ids || '',
      Physical_Status: physicalData.physicalStatus || '',
      Body_Type: physicalData.bodyType || '',
      Complexion: physicalData.complexion || '',
      Eating_Habits: physicalData.eatingHabits || '',
      Drinking_Habits: physicalData.drink || '',
      Smoking_Habits: physicalData.smoking || '',
      user_id: localStorage.getItem('user_id'),
      // tokan: localStorage.getItem('token'),
    },
    validationSchema: physicalDetailsSchema,
    onSubmit: async (values, { setSubmitting }) => {
      console.log(values);

      try {
        const response = await editLifeStyleDetails(values);
        if (response.status === 200 || response.status === 201) {
          setPopupData({ open: true, type: 'success', message: response.data.message });
          setTimeout(() => {
            navigate(-1);
          }, 3000);
        } else {
          setPopupData({ open: true, type: 'error', message: 'Failed to update Lifestyle' });

        }
      } catch (error) {
        setPopupData({ open: true, type: 'error', message: error.message || "An error occurred" });
      } finally {
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    const fetchWeight = async () => {
      try {
        const response = await getWeight();

        if (response.status === 200 || response.status === 201) {
          setWeight(response.data.data);
        } else {
          setPopupData({ open: true, type: 'error', message: 'Failed to fetch weight' });
        }
      } catch (error) {
        setPopupData({ open: true, type: 'error', message: error.message || "An error occurred" });
      }
    }

    const fetchAllStatus = async () => {
      try {
        const response = await getAllPhysicalStatus();
        if (response.status === 200 || response.status === 201) {
          setPhysicalStatus(response.data.data.physical_status);
          setBodyType(response.data.data.body_type);
          setComplexion(response.data.data.body_complexion);
          setEatingHabits(response.data.data.eating_habit);
          setDrinkingHabits(response.data.data.drink);
          setSmokingHabits(response.data.data.smoke);
        }
      }
      catch (error) {
        setPopupData({ open: true, type: 'error', message: error.message || "An error occurred" });
      }
    }
    fetchAllStatus();
    fetchWeight();
  }, []);
  return (
    <div className="col-lg-9 col-12">
      <Card className="editProfileBlock">
        <CardHeader
          avatar={
            <ArrowBackIcon sx={{ color: '#FF8008', cursor: 'pointer' }} onClick={() => navigate(-1)} />
          }
          title="My Lifestyle & Interests"
          subheader="Update your lifestyle & interests details to get suitable matches"
          titleTypographyProps={{ sx: { color: '#FF8008', fontSize: '20px', fontWeight: '500' } }}
        />
        <CardContent>
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Weights"
                  variant="outlined"
                  className="mb-3"
                  name="Weight"
                  value={formik.values.Weight} // Ensure this is initialized correctly
                  onChange={formik.handleChange} // Ensure onChange is included to update value
                  onBlur={formik.handleBlur}
                  error={formik.touched.Weight && Boolean(formik.errors.Weight)}
                  helperText={formik.touched.Weight && formik.errors.Weight}
                >
                  <MenuItem value=''>Select Weight</MenuItem>
                  {weight && weight.map((item, index) => (
                    <MenuItem key={index} value={item.weight_id}>{item.weight}</MenuItem>
                  ))}
                </TextField>
              </div>

              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Physical Status"
                  variant="outlined"
                  className="mb-3"
                  name="Physical_Status"
                  value={formik.values.Physical_Status}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.Physical_Status && Boolean(formik.errors.Physical_Status)}
                  helperText={formik.touched.Physical_Status && formik.errors.Physical_Status}
                >
                  <MenuItem value=''>Select Physical Status</MenuItem>
                  {physicalStatus.map((value, index) => (
                    <MenuItem key={index} value={value.id}>{value.Type}</MenuItem>
                  ))}
                </TextField>
              </div>

              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Body Type"
                  variant="outlined"
                  className="mb-3"
                  name="Body_Type"
                  value={formik.values.Body_Type}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.Body_Type && Boolean(formik.errors.Body_Type)}
                  helperText={formik.touched.Body_Type && formik.errors.Body_Type}
                >
                  <MenuItem value=''>Select Body Type</MenuItem>
                  {bodyType.map((value, index) => (
                    <MenuItem key={index} value={value.id}>{value.type}</MenuItem>
                  ))}
                </TextField>
              </div>
              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Complexion"
                  variant="outlined"
                  className="mb-3"
                  name="Complexion"
                  value={formik.values.Complexion}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.Complexion && Boolean(formik.errors.Complexion)}
                  helperText={formik.touched.Complexion && formik.errors.Complexion}
                >
                  <MenuItem value=''>Select Complexion</MenuItem>
                  {complexion.map((value, index) => (
                    <MenuItem key={index} value={value.id}>{value.type}</MenuItem>
                  ))}
                </TextField>
              </div>
              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Eating Habits"
                  variant="outlined"
                  className="mb-3"
                  name="Eating_Habits"
                  value={formik.values.Eating_Habits}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.Eating_Habits && Boolean(formik.errors.Eating_Habits)}
                  helperText={formik.touched.Eating_Habits && formik.errors.Eating_Habits}
                >
                  <MenuItem value="">Select Eating Habits</MenuItem>
                  {eatingHabits.map((value, index) => (
                    <MenuItem key={index} value={value.id}>
                      {value.Type}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Drinking Habits"
                  variant="outlined"
                  className="mb-3"
                  name="Drinking_Habits"
                  value={formik.values.Drinking_Habits}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.Drinking_Habits && Boolean(formik.errors.Drinking_Habits)}
                  helperText={formik.touched.Drinking_Habits && formik.errors.Drinking_Habits}
                >
                  <MenuItem value="">Select Drinking Habits</MenuItem>
                  {drinkingHabits.map((value, index) => (
                    <MenuItem key={index} value={value.id}>
                      {value.Type}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Smoking Habits"
                  variant="outlined"
                  className="mb-3"
                  name="Smoking_Habits"
                  value={formik.values.Smoking_Habits}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.Smoking_Habits && Boolean(formik.errors.Smoking_Habits)}
                  helperText={formik.touched.Smoking_Habits && formik.errors.Smoking_Habits}
                >
                  <MenuItem value="">Select Smoking Habits</MenuItem>
                  {smokingHabits.map((value, index) => (
                    <MenuItem key={index} value={value.id}>
                      {value.Type}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            </div>
            {/* <div className="d-grid col-4 mx-auto mt-2"> */}
            <Button type="submit" variant="contained" sx={{ backgroundColor: '#FF8008' }}>
              {formik.isSubmitting ? 'Saving...' : 'Save Changes'}
            </Button>
            {/* </div> */}
          </form>
        </CardContent>
      </Card>

      <Popup
        open={popupData.open}
        type={popupData.type}
        message={popupData.message}
        onClose={handleClosePopup}
      />
    </div >
  )
}
